import omit from 'lodash/fp/omit';
import type { UserProfile as Profile } from 'oidc-client-ts';
import type { RioProfile } from './loginSlice';

const stripSnakeProps = omit(['client_id']);

export const mapUserProfile = (profile: Profile): RioProfile => ({
    sub: profile.sub,
    clientId: profile.client_id as string,
    name: profile.name,
    email: profile.email,
    ...stripSnakeProps(profile),
});
